import { HCP_SCIENTIFIC_ACTIVITY_TOPIC_CUBE_NAME } from '@/api/hcp';
import { Stars } from '@/components/shared/rating';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { SelectItem } from '@/types/ui';
import { Filter } from '@cubejs-client/core';
import { TOPIC_FILTER_LIMIT } from '../../filterDefaultLimits';
import { FilterValue } from '../../FilterType';

const TOPIC_LABEL_DIMENSION = `${HCP_SCIENTIFIC_ACTIVITY_TOPIC_CUBE_NAME}.score_label`;
const TOPIC_SCORE_DIMENSION = `${HCP_SCIENTIFIC_ACTIVITY_TOPIC_CUBE_NAME}.score_value`;

const TOPIC_OPTIONS: GetOptionsQueryFunction = () => ({
  dimensions: [TOPIC_LABEL_DIMENSION],
  limit: TOPIC_FILTER_LIMIT,
});

const topicFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.topicLabel',
  placeholder: 'global.filters.formControls.topicPlaceholder',
  defaultValue: null,
  sourceCube: HCP_SCIENTIFIC_ACTIVITY_TOPIC_CUBE_NAME,
  getOptionsQuery: TOPIC_OPTIONS,
  mapResult: mapDimensionToOption(TOPIC_LABEL_DIMENSION),
  type: 'multilevelselect',
  searchable: true,
  clearable: true,
  format: ({ value, t }: { value: FilterValue; t: (key: string) => string }) => {
    const topicItem = value as SelectItem;
    const isOther = topicItem.value === 'other';
    const displayLabel = isOther ? 'Other' : topicItem.label;
    return (
      <>
        <span>{t('global.filters.topic')}:&nbsp;</span>
        <span>{displayLabel}</span>
        <Stars value={topicItem.level} />
      </>
    );
  },
  applyFilter: value => {
    const levelledTopics = value as SelectItem[];
    const filter: Filter = {
      or: levelledTopics.map(topic => {
        return {
          and: [
            {
              member: TOPIC_LABEL_DIMENSION,
              operator: 'equals',
              values: [topic.value],
            },
            {
              member: TOPIC_SCORE_DIMENSION,
              operator: 'gte',
              values: [topic.level.toString()],
            },
          ],
        };
      }),
    };
    return filter;
  },
};

export default topicFilter;
